<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__tcontractconfig}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="主键编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.docTemplateId" placeholder="E签宝模板编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品编号" prop="productCode">
        <el-select v-model="dataForm.productCode" placeholder="产品编号" clearable filterable>
          <el-option 
            v-for="item in productCode"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件类型编号" prop="contractTypeCode">
        <el-select v-model="dataForm.contractTypeCode" placeholder="文件编号" clearable filterable>
          <el-option 
            v-for="item in file_type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tcontractconfig:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:tcontractconfig:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键Id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="docTemplateId" label="E签宝模板Id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="loanNo" label="共借人人数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="contractTypeName" label="文件类型名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createBy" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="version" label="版本号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:tcontractconfig:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:tcontractconfig:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tcontractconfig-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/tcontractconfig/page',
        getDataListIsPage: true,
        exportURL: '/sys/tcontractconfig/export',
        deleteURL: '/sys/tcontractconfig',
        deleteIsBatch: true
      },
      file_type:[],
      productCode:[],
      dataForm: {
        id: '',
        docTemplateId: '',
        productCode: '',
        contractTypeCode: ''
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
     // 文件类型
     this.$http.get(`/sys/dict/data/list?dataType=file_type`).then(r=>{
      console.log(r)
     this.file_type = r.data.data ? r.data.data.map(item => ({
      value:item.dictValue,label:item.dictLabel
      })) : []
    })
    this.$http.get('/sys/dict/data/list?dataType=contract_product').then(r =>{
      this.productCode = r.data.data ? r.data.data.map(
        item => ({value:item.dictValue,label:item.dictLabel})
      ) : []
    })
  }
}
</script>